import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    position: "absolute",
    backgroundColor: theme.palette.gray30.main,
    borderRadius: 4,
    top: 50,
    zIndex: 10000,
  },
  line: {
    height: 1,
    padding: "0px 8px",
    backgroundColor: theme.palette.gray40.main,
  },
}));

export default useStyles;
